// Re-export transport utilities from shared @agentvault/crypto package.
// Plugin code continues importing from ./crypto-helpers.js — no import changes needed.
export {
  hexToBytes,
  bytesToHex,
  base64ToBytes,
  bytesToBase64,
  encryptedMessageToTransport,
  transportToEncryptedMessage,
  encryptedMessageToTransportV2Full,
  type TransportMessage,
  type TransportMessageV2,
} from "@agentvault/crypto";
